import { render, staticRenderFns } from "./ResourceUpLoad.vue?vue&type=template&id=318f3058&scoped=true&"
import script from "./ResourceUpLoad.vue?vue&type=script&lang=js&"
export * from "./ResourceUpLoad.vue?vue&type=script&lang=js&"
import style0 from "./ResourceUpLoad.vue?vue&type=style&index=0&id=318f3058&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318f3058",
  null
  
)

export default component.exports